import { PDFDocument, degrees, rgb } from 'pdf-lib'
import fontkit from '@pdf-lib/fontkit'
import { useState } from "react"
import moment from "moment";
// import constant from '../../../constant';

interface IPropType {
    detail: {
        loanId: any,
        borrowerName: any, borrowerEmail: any, borrowerSignature: any, borrowerSignatureDate: any,
        transactionNumber: any, transactionAmount: any, ctcDate: any, broker: any,
        coBorrowerName: any, coBorrowerEmail: any, coBorrowerSignature: any, coBorrowerSignatureDate: any,
        borrowerAddress: any
        // lenderName: any,
    }
}

function HeterIskaPDF(props: IPropType) {
    const page = '#page=5';
    const { detail } = props;
    const [stateDetail, setStateDetail]: any = useState(null);
    const [docURL, setDocURL]: any = useState(null);

    if (JSON.stringify(detail) !== JSON.stringify(stateDetail)) {
        generateBlob(detail).then((res: any) => {
            const _docURL = URL.createObjectURL(res);
            setDocURL(_docURL + page);
        })
        setStateDetail(detail);
    }

    if (docURL) {
        return <iframe title="Heter Iska" style={{ width: '100%', height: '100%' }} src={docURL} />
    }
    return <div>Loading...</div>
}

export async function generateBlob(detail: any) {
    const fontURL = '/fonts/calibril.ttf'
    const fontBytes = await fetch(fontURL).then(res => res.arrayBuffer())

    const url = `${process.env.REACT_APP_BASE_URL}/heter-iska/uwm.pdf`;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    pdfDoc.registerFontkit(fontkit)
    const customFont = await pdfDoc.embedFont(fontBytes)
    console.log(detail);
    const pages = pdfDoc.getPages();
    const fontSize = 12;
    //#region page 1
    const { height, width } = pages[2].getSize()
    pages[4].drawText(
        parseFloat(detail.transactionAmount).toLocaleString(undefined, { minimumFractionDigits: 0 }),
        {
            x: width - 356,
            y: height - 172,
            size: fontSize,
            font: customFont,
        });

    // date
    const _ctcDate = detail.ctcDate ? moment(detail.ctcDate) : moment();
    pages[4].drawText(
        _ctcDate.format("DD MMMM"),
        {
            x: width - 314,
            y: height - 232,
            size: fontSize,
            font: customFont,
        });

    pages[4].drawText(
        _ctcDate.format("YY"),
        {
            x: width - 222,
            y: height - 232,
            size: fontSize,
            font: customFont,
        });

    pages[4].drawText(
        "Capital Plus",
        {
            x: width - 368,
            y: height - 246,
            size: fontSize,
            font: customFont,
        });
    // // // receiver name
    pages[4].drawText(detail.borrowerName,
        {
            x: width - 356,
            y: height - 142,
            size: fontSize,
            font: customFont,
        });

    // pages[2].drawText(detail.borrowerAddress ? detail.borrowerAddress : '',
    //     {
    // rotate: degrees(-90),
    //         x: height - 38,
    //         y: width - 365,
    //         size: fontSize,
    //         font: customFont,
    //     });
    // // receiver address

    // // loan id
    pages[4].drawText(detail.loanId + " " + detail.bankReferenceNumber,
        {
            x: width - 356,
            y: height - 158,
            size: fontSize,
            font: customFont,
        });

    // pages[2].drawRectangle({
    // rotate: degrees(-90),
    //     x: height - 66,
    //     y: width - 284,

    //     width: 28,
    //     height: 10,
    //     borderWidth: 0,
    //     // borderColor: grayscale(0.5),
    //     // color: rgb(0.75, 0.2, 0.2),e8e8e8
    //     color: rgb(0.9098039215686274, 0.9098039215686274, 0.9098039215686274),
    //     opacity: 1,
    //     // borderOpacity: 0.75,
    // })
    // pages[2].drawText("Amount:",
    //     {
    // rotate: degrees(-90),
    //         x: height - 64.5,
    //         y: width - 285,
    //         size: 9.5,
    //         // font: customFont,
    //     });

    // pages[2].drawText(parseFloat(detail.transactionAmount).toLocaleString(undefined, { minimumFractionDigits: 0 }),
    //     {
    // rotate: degrees(-90),
    //         x: height - 64,
    //         y: width - 365,
    //         size: fontSize,
    //         font: customFont,
    //     });
    // // loan date
    // pages[0].drawText('You can modify PDFs too!');
    //#endregion

    //#region page 8
    // borrowerSignature: any, borrowerSignatureDate: any,
    if (detail.borrowerSignature) {
        const pngImageBytes = await fetch(detail.borrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes)
        const pngDims = pngImage.scale(0.25)

        pages[4].drawImage(pngImage, {
            x: width - 520,
            y: height - 382,

            width: pngDims.width,
            height: pngDims.height,
        })
    }
    if (detail.borrowerSignatureDate) {
        const md = moment(detail.borrowerSignatureDate);
        pages[4].drawText(md.format('DD'), {
            // rotate: degrees(-90),
            x: width - 442,
            y: height - 350,
            size: fontSize, font: customFont,
        });
        pages[4].drawText(md.format('MMMM'), {
            // rotate: degrees(-90),
            x: width - 390,
            y: height - 350,
            size: fontSize, font: customFont,
        });
        pages[4].drawText(md.format('YY'), {
            // rotate: degrees(-90),
            x: width - 304,
            y: height - 350,
            size: fontSize, font: customFont,
        });
    }
    // coBorrowerSignature, coBorrowerSignatureDate
    // pages[4].drawText(detail.borrowerName, {
    //     x: 63, y: (height - 433), size: fontSize, font: customFont,
    // });
    pages[4].drawText(detail.coBorrowerName, {
        // x: 315, y: (height - 433),
        x: width - 520,
        y: height - 490,
        size: fontSize, font: customFont,
    });

    if (detail.coBorrowerSignature) {
        const pngImageBytes = await fetch(detail.coBorrowerSignature).then((res) => res.arrayBuffer());
        const pngImage = await pdfDoc.embedPng(pngImageBytes);
        const pngDims = pngImage.scale(0.25)
        pages[4].drawImage(pngImage, {
            x: width - 520,
            y: height - 540,
            // x: 311,
            // y: pages[4].getHeight() - 387,
            width: pngDims.width,
            height: pngDims.height,
        })
    }

    if (detail.coBorrowerSignatureDate) {
        const md = moment(detail.coBorrowerSignatureDate);
        pages[4].drawText(md.format('DD'), {
            // rotate: degrees(-90),
            x: width - 250,
            y: height - 540,
            size: fontSize, font: customFont,
        });
        pages[4].drawText(md.format('MM'), {
            // rotate: degrees(-90),
            x: width - 280,
            y: height - 540,
            size: fontSize, font: customFont,
        });
        pages[4].drawText(md.format('YYYY'), {
            // rotate: degrees(-90),
            x: width - 224,
            y: height - 540,
            size: fontSize, font: customFont,
        });
    }
    //#endregion

    // pdfDoc.removePage(0);
    // pdfDoc.removePage(1);
    // pdfDoc.removePage(2);
    // pdfDoc.removePage(3);
    const pdfBytes = await pdfDoc.save();

    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    return Promise.resolve(blob);
}

export default HeterIskaPDF;